import MaintenanceIndex from "@/views/maintenance/MaintenanceIndex.vue";

const maintenanceRoutes = [
  {
    path: "/maintenances",
    name: "maintenances",
    component: MaintenanceIndex,
  },
];

export default maintenanceRoutes;
